export const ACCOUNTS = '/api/billing/customers'
export const RETAKE = '/api/qrcode/user-codes/retake'
export const VALIDATE = '/api/qrcode/user-codes/validate/admin'
export const CREATE_NEW = '/api/qrcode/user-codes/retake/create'
export const QR_SCAN_SUMMARY = '/api/qrcode/qr-scan-monitor/summary'
export const QR_SCAN_HOURLY = '/api/qrcode/qr-scan-monitor/hourly'
export const QR_SCAN_DOMAINS = '/api/qrcode/qr-scan-monitor/domains'
export const QR_SCAN_TOP_CODES = '/api/qrcode/qr-scan-monitor/top-codes'
export const QR_SCAN_DIMENSIONS = '/api/qrcode/qr-scan-monitor/dimensions'
export const QR_SCAN_CODE_DETAIL = '/api/qrcode/qr-scan-monitor/codes'
export const QR_CREATED_HOURLY = '/api/qrcode/qr-scan-monitor/created-hourly'
export const QR_CREATED_DIMENSIONS = '/api/qrcode/qr-scan-monitor/created-dimensions'
export const QR_CREATED_CODES = '/api/qrcode/qr-scan-monitor/created-codes'
export const QR_ASSIGN_GUEST_CODES = '/api/qrcode/user-codes/assign-guest'
export const URL_SCAN_SUMMARY = '/api/qrcode/url-scan/summary'
export const URL_SCAN_CODES = '/api/qrcode/url-scan/codes'
export const URL_SCAN_BULK = '/api/qrcode/url-scan/bulk'
export const SERVICE_PACKAGES = '/api/billing/plans'
export const SERVICE_PACKAGE_SUMMARY = '/api/billing/plans/admin-summary'
export const ADMINISTRATORS = '/admin/administrators'
export const ADMINISTRATOR_ROLES = '/admin/roles'
export const USER_REGISTRATION_HOURLY = '/identity/users/registrations/hourly'
export default {
    ACCOUNTS,
    RETAKE,
    VALIDATE,
    CREATE_NEW,
    QR_SCAN_SUMMARY,
    QR_SCAN_HOURLY,
    QR_SCAN_DOMAINS,
    QR_SCAN_TOP_CODES,
    QR_SCAN_DIMENSIONS,
    QR_SCAN_CODE_DETAIL,
    QR_CREATED_HOURLY,
    QR_CREATED_DIMENSIONS,
    QR_CREATED_CODES,
    QR_ASSIGN_GUEST_CODES,
    URL_SCAN_SUMMARY,
    URL_SCAN_CODES,
    URL_SCAN_BULK,
    SERVICE_PACKAGES,
    SERVICE_PACKAGE_SUMMARY,
    ADMINISTRATORS,
    ADMINISTRATOR_ROLES,
    USER_REGISTRATION_HOURLY
}
